import type { WineProductItem } from '@/common/domain-model/product-search';
import { Button, Modal } from 'antd';
import type { FC } from 'react';
import { DetailView } from './DetailView';
import { HeaderView } from './HeaderView';

export const DetailModalContent: FC<{
  productItem?: WineProductItem;
  open: boolean;
  onClose: () => void;
  onEdit: () => void;
}> = ({ productItem, open, onClose, onEdit }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={920}
      footer={[
        <Button key="back" onClick={onClose}>
          Close
        </Button>,
        <Button key="edit" type="primary" onClick={onEdit}>
          Edit Wine
        </Button>,
      ]}
    >
      {productItem && (
        <div className="border-b border-gray-200">
          <HeaderView productItem={productItem} />
          <DetailView productItem={productItem} />
        </div>
      )}
    </Modal>
  );
};
